import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_FETCH } from '../../services';
import { ENDPOINTS } from '../../constants/endpoints';

export interface Teams {
    lookupValueCd: string,
    lookupValueDesc: string
}

interface TeamsState {
    teams: Teams[];
    loading: boolean;
    error: string | null;
}

const initialState: TeamsState = {
    teams: [],
    loading: false,
    error: null,
};

// ========================================
// ASYNC THUNKS
// ========================================
/**
 * Fetch skill list by passing the site code as a query parameter
 * Uses: ENDPOINTS.GET_SKILLS + siteID
 */
export const fetchSkills = createAsyncThunk(
    'Teams/fetchTeams',
    async (_, { rejectWithValue }) => {
        try {
            const response = await API_FETCH(`${ENDPOINTS.GET_TEAMS}`);
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch teams');
        }
    }
);

// ========================================
// SLICE
// ========================================
const teamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSkills.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSkills.fulfilled, (state, action) => {
                state.loading = false;
                state.teams = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchSkills.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearError } = teamsSlice.actions;
export default teamsSlice.reducer;